import { Btn } from "../components/ui";

const EmailVerificationView = ({ email, setView }) => (
  <div style={{ maxWidth: 480, margin: "80px auto", padding: "0 24px", textAlign: "center" }} className="fade-up">
    <div style={{ fontSize: "48px", marginBottom: 16 }}>📧</div>
    <h2 style={{ fontSize: "30px", marginBottom: 10 }}>Check your email</h2>
    <p style={{ color: "var(--text-dim)", fontSize: "15px", lineHeight: 1.7, marginBottom: 12 }}>
      We've sent a verification link to
    </p>
    <p style={{ fontFamily: "var(--font-mono)", fontSize: "15px", color: "var(--amber)", marginBottom: 24 }}>{email}</p>
    <p style={{ color: "var(--text-dim)", fontSize: "14px", lineHeight: 1.7, marginBottom: 28 }}>
      Click the link in the email to verify your account, then come back here to sign in. If you don't see it, check your spam folder.
    </p>
    <Btn variant="ghost" onClick={() => setView("auth")}>Back to Sign In</Btn>
  </div>
);

export default EmailVerificationView;
